// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609100604/js/" + chunkId + "." + {"44":"ca27e3d7","225":"92a7ecec","481":"c53d16fa","486":"6c498902","770":"fed18a7d"}[chunkId] + ".0.5810915636890802.chunk.js";
};